import { EProductTypes } from '@/modules/catalog/services/products';
import { IInvestmentDetails } from '@/modules/transaction/services/product-investment';

export function errorText(
  data: IInvestmentDetails,
  inputValue: number,
  correctedValue: boolean,
  quantity: number,
  isEnabledSecondaryMarket: boolean
) {
  const {
    minimumInvestment,
    accountBalance,
    increment,
    maximumInvestmentQuantity
  } = data;

  if (inputValue > accountBalance.value) {
    return 'Valor maior que o saldo em conta';
  }

  if (inputValue > 0 && inputValue < minimumInvestment.value) {
    return 'Valor menor que o mínimo para investir';
  }

  if (
    isEnabledSecondaryMarket &&
    maximumInvestmentQuantity &&
    quantity > maximumInvestmentQuantity.value
  ) {
    return 'Quantidade maior que a máxima disponível';
  }

  if (correctedValue) {
    return `O valor precisa ser múltiplo de ${increment.formatted}. Já arredondamos ele para você`;
  }

  return '';
}

export function errorStatus(
  data: IInvestmentDetails,
  inputValue: number,
  quantity: number,
  isEnabledSecondaryMarket: boolean
) {
  const { minimumInvestment, accountBalance, maximumInvestmentQuantity } = data;

  if (inputValue > accountBalance.value) {
    return 'error';
  }

  if (inputValue > 0 && inputValue < minimumInvestment.value) {
    return 'error';
  }

  if (
    isEnabledSecondaryMarket &&
    maximumInvestmentQuantity &&
    quantity > maximumInvestmentQuantity.value
  ) {
    return 'error';
  }

  return '';
}

export function listDetails(
  data: IInvestmentDetails,
  productType: string,
  quantity: number,
  loading: boolean,
  isEnabledSecondaryMarket: boolean,
  maximumQuantity?: number | null
) {
  const { minimumInvestment, investmentWindow, unitPrice, currentBalance } =
    data;

  const list = [
    {
      label: currentBalance?.label || '',
      value: currentBalance?.formatted || '',
      loading: false,
      show: Boolean(currentBalance)
    },
    {
      label: 'Quantidade',
      value: String(quantity),
      loading,
      show: Boolean(productType !== EProductTypes.FUNDS)
    },
    {
      label: 'Quantidade máxima',
      value: String(maximumQuantity),
      loading,
      show:
        Boolean(productType === EProductTypes.FIXED_INCOME) &&
        isEnabledSecondaryMarket
    },
    {
      label: minimumInvestment.label,
      value: minimumInvestment.formatted,
      loading: false,
      show: Boolean(minimumInvestment)
    },
    {
      label: unitPrice?.label || '',
      value: unitPrice?.formatted || '',
      loading: false,
      show: Boolean(unitPrice)
    },
    {
      label: investmentWindow.label,
      value: investmentWindow.value,
      loading: false,
      show: Boolean(investmentWindow)
    }
  ];

  return list.filter(item => item.show);
}
